export const BORSZCZ = { id: 34, name: 'Borszcz w słoiku 440ml', price: 18 };



// WEBPACK FOOTER //
// ./src/constants/dishes.js